<script setup>
import { __ } from '@/utils';
import WhiteBox from '@components/whiteBox/whiteBox.vue';
import TrackingSteps from '@components/tracking-steps/tracking-steps.vue';
import { inject } from 'vue';

const { details } = inject('account');
</script>

<template>
    <WhiteBox>
        <div class="courier-box">
            <div class="courier-box__info">
                <h4>{{ __('Ordering equipment with a courier') }}</h4>
                <p>
                    <strong>{{ __('item') }}:</strong> {{ __('SIM card for line number') }} 052-3325213 <br/>
                    <strong v-if="details.value?.quotes?.number">{{ __('Order Number: ') }}</strong> {{details.value?.quotes?.number}}<br/>
                    <strong v-if="details.value?.quotes?.shipment_method_c">{{ __('Delivery method') }}:</strong> {{ details.value?.quotes?.shipment_method_c }}
                </p>
            </div>
            <div class="courier-box__tracking">
                <TrackingSteps />
            </div>
        </div>
    </WhiteBox>
</template>